"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementStaticService = exports.defineStaticService = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.defineStaticService = services_definitions_1.defineService;
exports.implementStaticService = services_definitions_1.implementService;
//# sourceMappingURL=staticService.js.map